import React from 'react';
import { Book } from '@/components/Icons/Book';

interface Props {
  lessonNumber?: number;
}

export const LessonNumber: React.FC<Props> = ({ lessonNumber }) => (
  <span className="flex size-5 shrink-0 items-center justify-center text-subhead-14 text-gray">
    {lessonNumber ?? <Book className="size-4" />}
  </span>
);
